<template>
  <div class="position-relative multi-select">
    <label class="d-flex"
      >{{ text }}<span v-show="isMandatory" class="asterik">*</span></label
    >
    <b-dropdown
      id="dropdown-multiselect"
      text="Select"
      class="w-100 multisel-dpd"
      no-caret
      @shown="isDropdownOpen = true"
      @hidden="isDropdownOpen = false"
    >
      <template #button-content>
        {{
          localSelectedItems.length > 0
            ? `${localSelectedItems.length} ${
                text === "Tags:" ? "Tag" : "Sheet"
              }${localSelectedItems.length > 1 ? "s" : ""} selected`
            : "Choose Sheets"
        }}
        <img
          class=""
          :class="!isDropdownOpen ? '' : ' up-arrow-rotate'"
          src="@/assets/images/common/down-arrow-sm.svg"
        />
      </template>
      <b-dropdown-form>
        <b-form-group>
          <b-form-input
            v-model="searchQuery"
            placeholder="Search"
            @update="filterItems"
            :debounce="debounce"
          ></b-form-input>
        </b-form-group>
        <b-form-checkbox-group
          v-model="localSelectedItems"
          v-if="filteredItems.length"
        >
          <b-form-checkbox
            v-for="item in filteredItems"
            :key="item.value"
            :value="item.text"
            @change="selectItem()"
          >
            {{ item.text }}
          </b-form-checkbox>
        </b-form-checkbox-group>
        <div
          v-else
          class="mt-2 d-flex justify-content-center align-items-center"
        >
          <h2 class="text-h2 fc-black fs-12 mb-2">
            No {{ text === "Tags:" ? "tags" : "sheets" }} found
          </h2>
        </div>
      </b-dropdown-form>
    </b-dropdown>
  </div>
</template>

<script>
export default {
  name: "MultiSelectSearch",
  props: {
    items: {
      type: Array,
      required: true,
    },
    isMandatory: {
      type: Boolean,
    },
    text: {
      type: String,
      default: "Label",
    },
    debounce: {
      type: Number,
      default: 500,
    },
    selectedItems: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchQuery: "",
      localSelectedItems: [...this.selectedItems],
      isDropdownOpen: false,
    };
  },
  watch: {
    items() {
      this.isDropdownOpen = false;
      this.localSelectedItems = [...this.selectedItems];
    },
  },
  mounted() {
    this.filteredItems = this.items;
  },
  computed: {
    filteredItems() {
      if (!this.searchQuery) return this.items;
      const query = this.searchQuery.toLowerCase();
      return this.items.filter((item) =>
        item.text.toLowerCase().includes(query)
      );
    },
  },
  methods: {
    filterItems() {
      this.$emit("searched", this.searchQuery);
    },
    selectItem() {
      this.$emit("selected", this.localSelectedItems);
    },
  },
};
</script>

<style>
.up-arrow-rotate {
  transform: rotate(179deg);
}
.multi-select .dropdown .btn-secondary {
  border: 1px solid #d0d5dd;
  background: var(--color-white) !important;
  height: 2.313rem;
  width: 100%;
  color: var(--subheading-color);
  font-family: "Montserrat", sans-serif;
  font-size: var(--size-14);
  font-weight: var(--weight-500);
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  border-radius: 8px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.multi-select .btn-secondary:not(:disabled):not(.disabled):active,
.multi-select .btn-secondary:not(:disabled):not(.disabled).active,
.multi-select .show > .btn-secondary.dropdown-toggle,
.multi-select .btn-secondary:not(:disabled):not(.disabled):active:focus,
.multi-select .btn-secondary:not(:disabled):not(.disabled).active:focus,
.multi-select .show > .btn-secondary.dropdown-toggle:focus {
  color: #667085 !important;
  border: 1px solid #d0d5dd;
  background-color: var(--color-white) !important;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
  font-family: "Montserrat";
  font-size: 14px;
  font-weight: var(--weight-400);
}
.multi-select .btn-secondary:focus,
.multi-select .btn-secondary.focus {
  color: var(--subheading-color);
  background-color: var(--color-white);
  border-color: #d0d5dd;
  box-shadow: 0px 1px 2px 0px rgba(16, 24, 40, 0.05);
}
.multi-select .custom-control-inline {
  display: flex !important;
  margin-left: 0.5rem;
  margin-bottom: 5px;
}
.multi-select .b-dropdown-form {
  padding: 0.2rem 0.2rem;
  width: 100%;
}
.multi-select .custom-control-input:checked ~ .custom-control-label::before {
  color: #fff;
  border-color: #20639b;
  background-color: #20639b;
}

.multi-select .custom-control-input:checked ~ .custom-control-label::after {
  border-color: #20639b;
  background-color: #20639b;
  border-radius: 0.25rem;
}
.multi-select .custom-control-input:focus ~ .custom-control-label::before {
  box-shadow: unset;
}
.multi-select .custom-control-label {
  position: relative;
  margin-bottom: 0;
  width: 100%;
  vertical-align: top;
  font-size: 13px;
  font-family: "Lato";
  font-weight: var(--weight-400);
  padding-top: 4px;
  color: #3a3c40;
}
.multi-select .dropdown-menu {
  position: absolute;
  top: 100%;
  left: 0;
  z-index: 1000;
  display: none;
  float: left;
  width: 100%;
  min-width: 100%;
  padding: 0 0;
  margin: 0.2rem 0 0;
  font-size: var(--size-16);
  list-style: none;
  background-color: rgba(249, 249, 249, 1);
  background-clip: padding-box;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 0.25rem;
  filter: drop-shadow(0px 16px 15px rgba(0, 0, 0, 0.4));
  min-height: auto;
  max-height: 222px;
  overflow-y: auto;
}
.multi-select .custom-control-label {
  display: block;
  /* padding: 0.5rem 0.5rem; */
  font-weight: var(--weight-R);
  color: #3a3c40;
  background-color: transparent;
  border: none;
  font-family: "Lato", sans-serif;
  font-size: var(--size-13);
  font-weight: var(--weight-500);
  cursor: pointer;
}
.multi-select .form-group {
  margin-bottom: 0.3rem;
}
.multi-select .btn-group {
  width: 100%;
}
.multi-select .dropdown-menu.show {
  display: block !important;
}
.multi-select .custom-control-label:hover,
.multi-select .custom-control-label:focus {
  color: var(--subheading-color);
  text-decoration: none;
  background-color: rgba(32, 99, 155, 0.05);
}
.multi-select .dropdown-item:active {
  color: var(--subheading-color);
  text-decoration: none;
  background-color: #c8d9e5;
}
.multi-select .btn-secondary:not(:disabled):not(.disabled):active,
.multi-select .btn-secondary:not(:disabled):not(.disabled).active,
.multi-select .show > .btn-secondary.dropdown-toggle {
  color: #3a3c40 !important;
  background-color: #ffffff !important;
}
.multi-select .form-control {
  width: 100%;
  padding: 0.375rem 0.75rem;
  font-size: 13px;
  font-weight: var(--weight-500);
  color: #3a3c40;
  font-family: "lato";
  background-clip: padding-box;
  background: #e8eff4;
  border: 1px solid #ffffff;
  border-style: solid;
  border-color: #ffffff;
  border-radius: 0.25rem;
}
</style>
